export default "__VITE_ASSET__dbea0ed0__"